export default class MassiaValidateController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'MassiaSelectService',
		'notification',
		'$location',
		'$translate',
		'SharedDataService',
		'$http'
	];

	constructor($scope, $state, $stateParams, MassiaValidateService, notification, $location, $translate, SharedDataService, $http) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.MassiaValidateService = MassiaValidateService;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$http = $http;
		this.ngModels = {};
		///// variables
		this.icon = '';
		this.isProcessing = false;
	}

	async $onInit() {
		if (this.config) {
			if (this.config.icon == 'ADD') {
				this.icon = 'glyphicon glyphicon-plus';
			} else this.icon = this.config.icon;
		}
	}

	cancelForm() {
		if (this.callbackClose) this.callbackClose();
	}

	validateForm() {
		this.isProcessing = true;
		this.executeUrl()
			.then((result) => {
				if (this.callbackValid) this.callbackValid({ result });
			})
			.finally(() => {
				this.isProcessing = false;
			});
	}

	validateFormAndClose() {
		this.isProcessing = true;
		this.executeUrl()
			.then((result) => {
				if (this.callbackValidAndClose) this.callbackValidAndClose({ result });
			})
			.finally(() => {
				this.isProcessing = false;
			});
	}

	async executeUrl() {
		let url = `${__configuration.apiUrl}` + this.config.route;
		console.log('-------------------------------------------------------------------------------------------');
		console.log('METHODE POST :');
		console.log(url);
		console.log(this.SharedDataService.getAllData());
		console.log('-------------------------------------------------------------------------------------------');
		const data = this.SharedDataService.getAllData();

		try {
			var result = await this.$http.post(url, data);

			console.log('--------------------------------------------');
			console.log('---               RESULT                 ---');
			console.log('--------------------------------------------');
			console.log(result);
			console.log('result2');
			console.log(JSON.parse(JSON.stringify(result)));
			console.log('-------------------------------------------------------------------------------------------');

			await this.SharedDataService.setAllData(result.data.data);
			console.log('result setAllData');
			// Gestion des retour pour l'affichage d'un POPUP (exemple dans CessionsController.cs)
			// public async Task<IHttpActionResult> Post([FromBody] CessionAutoriseDto data)
			// return Ok(new { success = false, message = "ERROR" });
			// return Ok(new { success = command.Success, message = command.Message });
			const dto = result.data.data;

			if (result.data.success == false) {
				console.log('result success false');
				this.notification.error(result.data.message);
				return false;
			} else {
				this.notification.success(result.data.message);

				if (!dto.id || dto.id.value === undefined || dto.id.value === null) {
					return false;
				}

				return result.data.data.id.value;
			}
		} catch (error) {
			this.notification.error(error.data);
			console.error('Erreur lors de la requête POST :', error);
			//alert(error.data.message);
		}
	}

	$onDestroy() {
		// Nettoyage si nécessaire
	}
}
